import React, { useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import lightStyles from './portalStylesLight.module.css';
import darkStyles from './portalStylesDark.module.css';

interface Props {
  onAdd: (codes: { id: string; description: string }[]) => void;
  onClose: () => void;
  format: string;
  lightMode: boolean;
  example: string;
  params: number;
  validate: (codes: { id: string; description: string }[]) => string | null;
}

const AddDialogue: React.FC<Props> = ({
  onAdd,
  onClose,
  format,
  lightMode,
  example,
  params = 2,
  validate = () => null
}) => {
  const styles = lightMode ? lightStyles : darkStyles;

  const [input, setInput] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleAdd = () => {
    if (!input.trim()) return;

    const newCodes = input
      .split(/\r?\n/)
      .filter((line) => line.trim())
      .map((line) => {
        if (params === 1) {
          return { id: line.trim(), description: '' };
        }

        const firstSpaceIndex = line.indexOf(' ');
        if (firstSpaceIndex === -1) {
          return { id: line.trim(), description: '' };
        }

        const id = line.slice(0, firstSpaceIndex).trim();
        const description = line.slice(firstSpaceIndex + 1).trim();
        return { id, description };
      });

    if (validate) {
      const validationError = validate(newCodes);
      if (validationError) {
        setError(validationError);
        return;
      }
    }

    onAdd(newCodes);
    setInput('');
    setError(null);
    onClose();
  };

  return (
    <ClickAwayListener onClickAway={onClose}>
      <div className={styles.dropdownContainer}>
        <div className={styles.dropdownContent}>
          <h3>Add Items</h3>
          <p>Items (one item per line)</p>
          <p>Format: {format}</p>
          <p>Example: {example}</p>
          <textarea
            className={styles.codeInput}
            value={input}
            style={{ resize: 'none' }}
            onChange={(e) => setInput(e.target.value)}
            rows={5}
          />
          {error && (
            <div className={styles.errorMessage} style={{ color: 'red', marginBottom: 8 }}>
              {error}
            </div>
          )}
          <div className={styles.dropdownButtons}>
            <button type="button" onClick={onClose} className={styles.secondaryButton}>
              Cancel
            </button>
            <button type="button" onClick={handleAdd} className={styles.primaryButton} disabled={!input.trim()}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default AddDialogue;
